export default __webpack_public_path__ + "3cdd4385085ec2962fb95db6a431356e.png";